import React, { useState } from 'react';
import { Tooltip } from 'antd';
import RenameModal from './RenameModal';
import { EditOutlined } from '@ant-design/icons';
import { useDocument } from '../../Pages/SpreadsheetContainer/documentInfoContex';
import './styles.css';

const DocumentTitle = ({ isMobile }) => {
    const { documentInfo, templateData, isTemplateDocument, isReadOnly } = useDocument();
    const [renameModalVisible, setRenameModalVisible] = useState(false);
    const name = isTemplateDocument ? (templateData ? templateData.name : "Template") : (documentInfo ? documentInfo.name : "New Board");

    return (
        <>
            <div className="document-title-container">
                <Tooltip title={name}>
                    <h1 className={`document-title-h1 ${isMobile ? 'mobile' : ''}`}>
                        {name}
                    </h1>
                </Tooltip>
                {!isReadOnly && (
                    <Tooltip title="Rename">
                        <span className={`document-title-edit-icon ${isMobile ? 'mobile' : ''}`}
                            onClick={() => setRenameModalVisible(true)}
                        >
                            <EditOutlined style={{ display: 'block', borderBottom: 'none', textDecoration: 'none' }} />
                        </span>
                    </Tooltip>
                )}
            </div>
            <RenameModal
                visible={renameModalVisible}
                onClose={() => setRenameModalVisible(false)}
            />
        </>
    );
};

export default DocumentTitle;